module.exports = __webpack_public_path__ + "img/ennetix-users-tab.52eeea37.png";